import React, { useState } from "react";
import { Menu, Dropdown } from "antd";
import { connect } from "react-redux";
import { fetch } from "../../actions";
import { useHistory } from "react-router-dom";
import Lancamento from "../Lancamento/Lancamento";
import Transferencia from "../Transferencia/Transferencia";
import AbrirFecharCaixa from "../AbrirFecharCaixa/AbrirFecharCaixa";
import VendaConsultaModal from "../Venda/VendaConsultaModal";
import VendaDevolucaoAvulsaModal from "../Venda/VendaDevolucaoAvulsaModal";
import Contas from "../Contas/Contas";
import TransferenciaReceberRejeitar from "../Transferencia/TransferenciaReceberRejeitar";
import { useValidarUsuario } from "../../components/Hooks/useValidarUsuario";
import LoadingScreen from "../../components/LoadingScreen";

function MenuPadrao(props) {
  const [lancId, setLancId] = useState(null);
  const [modalVisible, setModalVisible] = useState(null);
  const [validar, validando] = useValidarUsuario(props.fetch);
  const history = useHistory();

  const fmtStr = (str, maxSize) => str?.length > maxSize ? str.substring(0, maxSize) + "..." : str;
  const labelEmp = props.auth?.empresa?.fantasia || props.auth?.empresa?.razaoSocial;

  const func = <Menu theme="dark" style={{ marginTop: 20 }}>
    {window.innerWidth < 1360 && <>
      <Menu.Item key="empresa" title={labelEmp}><b>Empresa:</b> {`${fmtStr(labelEmp, 25)} - ${(props.auth?.empresa?.cnpj || "").replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")}`}</Menu.Item>
      <Menu.Item key="operador" title={props.auth.user}><b>Operador:</b> {fmtStr(props.auth.user, 15)}</Menu.Item>
    </>}
    <Menu.Item key="pdv" onClick={() => history.push("/")}>Pdv</Menu.Item>
    <Menu.Item key="abrir" onClick={() => setModalVisible("caixa")}>Abrir/Fechar</Menu.Item>

    {!!props.isCaixaAberto && <>
      {/* <Menu.Item key="transf" onClick={() => setModalVisible("trans")}>Transferência</Menu.Item>
      <Menu.Item key="transrecrej" onClick={() => setModalVisible("transrecrej")}>Receber/Rejeitar Transferência</Menu.Item> */}
      <Menu.Item key="consulta" onClick={() => validar("acessarConsultaVenda", null, () => setModalVisible("venda"))}>Venda consulta</Menu.Item>
      <Menu.Item key="devavulsa" onClick={() => setModalVisible("devavulsa")}>Devolução avulsa</Menu.Item>
      <Menu.Item key="lanc" onClick={() => setLancId(-1)}>Lançamento</Menu.Item>
      <Menu.Item key="mov" onClick={() => history.push("/movimentacao")}>Movimentação</Menu.Item>
      {props.online && <Menu.Item key="baixa" onClick={() => setModalVisible("baixa")}>Baixa de título</Menu.Item>}
    </>}

    <Menu.Item key="sair" onClick={() => history.push("/sair")}>Sair</Menu.Item>
  </Menu>;

  return <>
    <Dropdown overlay={func}><span className="font-color-menu" style={{ fontSize: 18, cursor: "pointer" }}>Caixa Menu</span></Dropdown>
    <Lancamento id={lancId} onOk={() => setLancId(null)} onCancel={() => setLancId(null)} />
    <Transferencia visible={modalVisible == "trans"} onOk={() => setModalVisible(null)} onCancel={() => setModalVisible(null)} />
    <TransferenciaReceberRejeitar visible={modalVisible == "transrecrej"} onCancel={() => setModalVisible(null)} />
    <AbrirFecharCaixa visible={modalVisible == "caixa"} onOk={() => setModalVisible(null)} onCancel={() => setModalVisible(null)} />
    <Contas visible={modalVisible == "baixa"} onOk={() => setModalVisible(null)} onCancel={() => setModalVisible(null)} />
    <VendaConsultaModal visible={modalVisible == "venda"} onCancel={() => setModalVisible(null)} />
    <VendaDevolucaoAvulsaModal visible={modalVisible == "devavulsa"} onCancel={() => setModalVisible(null)} />

    <LoadingScreen loading={validando} opacity={0.5} />
  </>;
}

const mapStateToProps = state => ({ auth: state.auth, isCaixaAberto: state.auth.caixaAberto, online: state.connection.online });

export default connect(mapStateToProps, { fetch })(MenuPadrao);
